
$(function () {
    document.createElement("notification");

    $("notification").each(function (_, element) {
        elements_notification_fetch_all(element);
    });
});

function elements_notification_fetch_all(element) {
    var url = $(element).data("url");

    $.ajax({
        url: url,
        cache: false,
        method: "GET",
        success: function (d) {

            if (d && d.success) {
                $(element).find("span").html(d.count.toString());
                if (d.count > 0) {
                    $(element).removeClass("notification-collapsed");
                }
            }
            else {
                //TODO: handle error
            }
        },
        error: function (s, x, e) {
            //TODO: handle error
        }
    })
}